export default function getDeviceHash() {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify({ data: "getHash" }));
  }
}
